import apiPaths from '../api-paths';

export default {
  sendResetEmail({ personId }) {
    return axios.post(`${ apiPaths.API }/password/forgot/${ personId }`);
  },
};
